import { render, staticRenderFns } from "./ScreenDevicePhoto.vue?vue&type=template&id=73af2e97&"
import script from "./ScreenDevicePhoto.vue?vue&type=script&lang=ts&"
export * from "./ScreenDevicePhoto.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports